// Resolução de nome de cliente para as telas (Works, WorkPanel, WorksSummary,
// ExportObra). A fonte de verdade é o ClienteCache (tabela `clientes` no
// Supabase). A tabela LEGACY_CLIENTES existe apenas para resolver ids antigos
// ("1".."6") gravados em obras criadas quando os clientes eram mock — não é
// exibida em nenhum seletor.
import { ClienteCache, clienteDisplayName } from "@/services/clienteCache";

const LEGACY_CLIENTES: Record<string, string> = {
  "1": "Cliente A Ltda",
  "2": "Cliente B S.A.",
  "3": "Cliente C Eireli",
  "4": "Roberto Silva",
  "5": "Marina Costa",
  "6": "Eduardo Santos",
};

const UUID_RE = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

export function getClienteNomeById(id: string): string {
  const cliente = ClienteCache.getClienteById(id);
  if (cliente) return clienteDisplayName(cliente);
  if (LEGACY_CLIENTES[id]) return LEGACY_CLIENTES[id];
  // uuid de cliente removido => rótulo genérico; texto livre => exibe como está
  return UUID_RE.test(id) ? "Cliente" : id;
}
